import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { PaymentLayoutActions, PaymentLayoutActionTypes } from './../actions/payment-layout.action';
import { Jobsite } from './../../models/jobsite';

export interface State extends EntityState<Jobsite> { }

const adapter: EntityAdapter<Jobsite> = createEntityAdapter<Jobsite>({
    selectId: (jobsite: Jobsite) => jobsite.jobsiteCode,
    sortComparer: false
});

const initialState: State = adapter.getInitialState();

export function reducer(state = initialState, action: PaymentLayoutActions): State {
    switch (action.type) {
        case PaymentLayoutActionTypes.CLEAR_JOBSITES: {
            return initialState;
        }

        case PaymentLayoutActionTypes.LOAD_JOBSITES_SUCCESS: {
            return adapter.addMany(action.payload, state);
        }

        default: {
            return state;
        }
    }
}

export const getJobsites = (state: State) => state && state.entities;
